import { Button, CircularProgress, Modal, TextField } from "@mui/material";
import axios from "axios";
import { getUrl } from "common/components/apiConfig";
import { convertDigitToEnglish } from "common/method/convertDigitToEnglish";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";
import { MdOutlineKeyboardAlt, MdOutlineRefresh } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Keyboard from "react-simple-keyboard";
import { actionTypes as loginType } from "redux/login";
import { getUSer } from "redux/login/getUser";
import { RouteContext } from "routes";
import * as Yup from "yup";
import auth from "../login/login/auth";
import { useTheme } from "@mui/styles";

const LoginPass = ({ setflagLogin, flagLogin, query_national_member_id }) => {
  const history = useHistory();
  const { login } = auth();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [showPass, setshowPass] = useState(false);
  const { path, setPath } = useContext(RouteContext);
  const [showKeyEmail, setShowKeyEmail] = useState(false);
  const [showKeyPass, setShowKeyPass] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const [inputEmail, setInputEmail] = useState(query_national_member_id || "");
  const [inputPass, setInputPass] = useState("");
  const theme = useTheme();
  const handleClickPass = () => {
    setshowPass((prev) => !prev);
  };

  const [apiResponse, setApiResponse] = useState(null);
  const [shouldFetchData, setShouldFetchData] = useState(true);

  const fetchData = async () => {
    try {
      const response = await apiCall();
      setApiResponse(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (shouldFetchData) {
      fetchData();
      setShouldFetchData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchData]);

  const apiCall = () => {
    let config = {
      baseURL: getUrl(),
      method: "POST",
      headers: {
        "content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: "login",
      data: {
        api_key: "d025488f-8ec6-4434-afbe-b6a5343815a7",
        token: null,
        member_id: null,
        table: "clubmember",
        method_type: "get_captcha",
        data: {},
      },
    };

    return axios(config);
  };

  const base64Image = apiResponse?.response?.data?.img;
  const imgSrc = base64Image?.startsWith("data:image")
    ? base64Image
    : `data:image/jpeg;base64,${base64Image}`;

  const initialValues = {
    email: "",
    password: "",
    captcha: "",
  };

  let errorPassword =
    "رمز عبور باید ۸ کاراکتر و شامل عدد و حروف کوچک و بزرگ انگلیسی باشد";

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      //   .matches(numberRegExp, "فقط می توانید  عدد انگلیسی وارد نمایید")
      //   .min(10, "کد ملی/شناسه ملی حداقل باید 10 رقم و به صورت عدد باشد")
      //   .max(11, "کد ملی/شناسه ملی حداکثر باید 11 رقم و به صورت عدد باشد")
      .required("وارد کردن نام کاربری الزامی است"),
    password: Yup.string()
      .min(8, "حداقل باید 8 رقم  باشد")
      .required("وارد کردن رمز عبور الزامی است")
      // .matches(
      //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      //   errorPassword
      // ),
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d*@$!%*#?&]{8,}$/,
        errorPassword,
      ),
    captcha: Yup.string().required("وارد کردن کد امنیتی الزامی است."),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };
  const handleRoute = () => {
    const pathSession = sessionStorage.getItem("redirectpath");

    const url = new URL(window.location.href);
    const page = url.searchParams.get("page");
    const memberId = url.searchParams.get("memberId");

    if (path?.length || pathSession) {
      history.push(`${path || pathSession}`);
      setPath("");
      sessionStorage.removeItem("redirectpath");
      return;
    }

    if (page) {
      const decodedPath = decodeURIComponent(page);
      history.push(decodedPath);
      return;
    }

    history.push("/home");
    sessionStorage.removeItem("redirectpath");
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  /**
   @todo: The backend is  to remove the permitted methods from the response.
**/
  let setCookieStorageLogin = async (obj) => {
    try {
      if (obj && obj.user?.member_permitted_methods) {
        delete obj?.user?.member_permitted_methods;
      }
      const is_expired = obj?.user?.is_expired;
      const objString = obj && JSON.stringify(obj);
      const objString1 = is_expired && JSON.stringify(is_expired);

      const encodedName = encodeURIComponent("admin");
      const encodedValue = encodeURIComponent(objString);

      let cookieString = encodedName + "=" + encodedValue;
      let cookieString1 = encodeURIComponent("is_expired") + "=" + objString1;

      const isDev = process.env.REACT_APP_IS_DEV === "true";
      cookieString += "; max-age=" + (1 * 24 * 60 * 60) / 24;
      cookieString += "; path=/";
      if (!isDev) {
        cookieString += "; Secure";
      }

      cookieString += "; SameSite=Lax";

      document.cookie = cookieString;
      document.cookie = cookieString1;
    } catch (error) {
      console.error("Error setting cookie:", error);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const ENGemail = convertDigitToEnglish(values.email);
      const ENGpassword = convertDigitToEnglish(values.password);
      const ENGCaptcha = convertDigitToEnglish(values.captcha);
      enableLoading();
      setLoading(true);
      setTimeout(() => {
        getUSer(
          ENGemail,
          ENGpassword,
          ENGCaptcha,
          apiResponse?.response?.data?._id,
        )
          .then((res) => {
            if (!Object.keys(res.data.response.data).length) {
              handleNotificationAlertTrySelect(res);
              return;
            }
            dispatch({
              type: loginType.login,
              payload: res.data.response.data,
            });
            let obj = {
              authToken: res.data.response.data.token,
              authMemberId: res.data.response.data.member_id,
              user: res.data.response.data,
              authenticated: true,
              startTime: new Date(),
            };

            setCookieStorageLogin(obj);
            login(() => handleRoute());
          })
          .catch(() => {
            handleNotificationAlertCatch();
          })
          .finally(() => {
            disableLoading();
            setSubmitting(false);
            setLoading(false);
            setShouldFetchData(true);
          });
      }, 1000);
    },
  });

  const handleClearInput = () => {
    setInputPass("");
    formik.setFieldValue("password", "");
  };

  const onChange = (newInput) => {
    if (showKeyEmail) {
      return setInputEmail(newInput);
    } else if (showKeyPass) {
      return setInputPass(newInput);
    }
  };

  const onKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const handleShift = () => {
    setLayoutName((prevLayout) =>
      prevLayout === "default" ? "shift" : "default",
    );
  };

  useEffect(() => {
    console.log("querry_member", query_national_member_id);
    formik.setFieldValue("email", inputEmail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputEmail]);
  useEffect(() => {
    formik.setFieldValue("password", inputPass);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputPass]);
  const handleRefreshClick = () => {
    setShouldFetchData(true);
  };

  const isDisabled = formik.values.password.length < 8;

  return (
    <>
      <div className="flex flex-col">
        <div className="font-medium mt-3 " style={{ fontSize: 14 }}>
          لطفا نام کاربری و رمز عبور خود را وارد کنید
        </div>

        <form
          onSubmit={formik.handleSubmit}
          // className="form fv-plugins-bootstrap fv-plugins-framework"
        >
          <div className="fv-plugins-icon-container mt-5">
            {showKeyEmail && (
              <Modal
                sx={{
                  "& .muirtl-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                    backgroundColor: "transparent",
                  },
                }}
                open={showKeyEmail}
                onClose={() => {
                  setShowKeyEmail(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
              >
                <div
                  style={{
                    display: "flex",
                    backgroundColor: theme.palette.background.paper,
                    zIndex: 100,
                    borderRadius: 5,
                    position: "absolute",
                    top: "50%",
                    left: "49%",
                    transform: "translate(-50%, -55%)",
                    outline: 0,
                    border: 0,
                    boxShadow: 24,
                    maxWidth: "100%",
                    width: "auto",
                    maxHeight: "80vh",
                    overflowY: "auto",
                  }}
                >
                  {" "}
                  <div style={{ direction: "ltr" }}>
                    <Keyboard
                      input={inputEmail}
                      layoutName={layoutName}
                      onChange={onChange}
                      onKeyPress={onKeyPress}
                      maxLength={10}
                    />
                  </div>
                </div>
              </Modal>
            )}
            <div className="fv-plugins-icon-container relative mt-5 border rounded-md ">
              <input
                placeholder="نام کاربری"
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                className={`w-full text-right border h-12 py-4 px-5 focus:border-gray-400 outline-none rounded-md ${getInputClasses(
                  "email",
                )} authInput`}
                name="email"
                {...formik.getFieldProps("email")}
                onChange={(event) => {
                  formik.setFieldValue(
                    "email",
                    event.target.value.replace(/\s/g, ""),
                  );
                }}
              />
              <div className="absolute top-[13px] left-4 text-gray-600 cursor-pointer">
                <MdOutlineKeyboardAlt
                  onClick={() => setShowKeyEmail((prev) => !prev)}
                  size={25}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            <div className={`errorPlace`}>
              {formik.touched.email && formik.errors.email ? (
                <div className="fv-plugins-message-container flex mt-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    fill="red"
                    className="bi bi-exclamation-triangle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                  </svg>
                  <div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
                    {formik.errors.email}
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          <div className="fv-plugins-icon-container relative mt-5 border rounded-md ">
            {showKeyPass && (
              <Modal
                sx={{
                  "& .muirtl-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                    backgroundColor: "transparent",
                  },
                }}
                open={showKeyPass}
                onClose={() => {
                  setShowKeyPass(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
              >
                <div
                  style={{
                    display: "flex",
                    backgroundColor: theme.palette.background.paper,
                    zIndex: 100,
                    borderRadius: 5,
                    position: "absolute",
                    top: "50%",
                    left: "49%",
                    transform: "translate(-50%, -18%)", // Adjusted transform values
                    outline: 0,
                    border: 0,
                    boxShadow: 24,
                    maxWidth: "100%", // Added maximum width for responsiveness
                    width: "auto", // Added auto width for responsiveness
                    maxHeight: "80vh", // Added maximum height for responsiveness
                    overflowY: "auto", // Added overflow for vertical scrolling if needed
                  }}
                >
                  <div style={{ direction: "ltr" }}>
                    <Keyboard
                      input={inputPass} // Pass the input directly
                      layoutName={layoutName}
                      onChange={onChange}
                      onKeyPress={onKeyPress}
                    />
                  </div>
                </div>
              </Modal>
            )}
            <input
              placeholder="رمز عبور"
              type={showPass ? "text" : "password"}
              className={`w-full  h-12 py-4 px-5 focus:border-gray-400 outline-none rounded-md ${getInputClasses(
                "password",
              )} authInput`}
              name="password"
              onChange={formik.handleChange}
              value={formik.values.password}
              {...formik.getFieldProps("password")}
            />

            <div
              className="absolute top-3 left-12 text-gray-600 cursor-pointer"
              onClick={() => handleClickPass()}
            >
              {showPass ? (
                <AiOutlineEyeInvisible size={25} />
              ) : (
                <AiOutlineEye size={25} />
              )}
            </div>
            <div className="absolute top-[13px] left-4 text-gray-600 cursor-pointer">
              <MdOutlineKeyboardAlt
                size={25}
                onClick={() => setShowKeyPass((prev) => !prev)}
                style={{ cursor: "pointer" }}
              />
            </div>
            {formik.values.password !== null && (
              <div className="absolute top-[13px] left-20 text-gray-600 cursor-pointer">
                <IoMdClose size={22} onClick={() => handleClearInput()} />
              </div>
            )}
          </div>
          <div className={`errorPlace`}>
            {formik.touched.password && formik.errors.password ? (
              <div className="fv-plugins-message-container flex mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="red"
                  className="bi bi-exclamation-triangle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
                <div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
                  {formik.errors.password}
                </div>
              </div>
            ) : null}
          </div>
          <div className="fv-plugins-icon-container mt-5  ">
            <div className="flex items-center">
              <TextField
                size="small"
                placeholder="کد امنیتی"
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                sx={{}}
                className={`w-full border h-12 py-4  focus:border-gray-400 outline-none rounded-md ${getInputClasses(
                  "captcha",
                )} authInput`}
                name="captcha"
                {...formik.getFieldProps("captcha")}
                onChange={(event) => {
                  formik.setFieldValue(
                    "captcha",
                    event.target.value.replace(/\s/g, ""),
                  );
                }}
                InputProps={{
                  endAdornment: (
                    <>
                      {apiResponse?.response?.data?.img ? (
                        <img
                          style={{ maxHeight: 36 }}
                          height={16}
                          alt=""
                          src={imgSrc}
                        />
                      ) : (
                        <div
                          style={{
                            minWidth: 70,
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <CircularProgress size={16} />
                        </div>
                      )}
                      <MdOutlineRefresh
                        onClick={handleRefreshClick}
                        style={{ cursor: "pointer", marginInlineStart: 4 }}
                        size={44}
                      />
                    </>
                  ),
                }}
                inputProps={{
                  style: {
                    textAlign: "right",
                    direction: "rtl",
                  },
                }}
              />
            </div>
            <div className={`errorPlace`}>
              {formik.touched.captcha && formik.errors.captcha ? (
                <div className="fv-plugins-message-container flex mt-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    fill="red"
                    className="bi bi-exclamation-triangle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                  </svg>
                  <div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
                    {formik.errors.captcha}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <Button
            type="submit"
            disabled={isDisabled || formik.isSubmitting}
            variant="contained"
            fullWidth
            sx={{
              height: 40,
              marginY: 2,
              "&.Mui-disabled": {
                bgcolor: theme.palette.action.disabledBackground,
                color: theme.palette.text.disabled,
              },
            }}
          >
            {loading ? <CircularProgress size={30} /> : "ورود"}
          </Button>
        </form>
        <div className="w-full flex justify-between mb-10 ">
          <div
            className="text-sm text-primary flex justify-start w-full cursor-pointer "
            onClick={() => setflagLogin(0)}
          >
            <span className="border-b-2 border-primary">ورود با پیامک</span>
          </div>
          <div
            className=" text-sm text-primary flex justify-end w-full cursor-pointer "
            onClick={() => setflagLogin(3)}
          >
            <span className="border-b-2 border-primary">فراموشی رمز عبور</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPass;
